<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><a id="page_24"></a><a id="page_25"></a><a id="part1"></a><em>Part One</em></p>
<h2 class="h2">WATER RISING</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230617063_08_pa01.vue?77e5b39f